import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import Heading from './Heading';
import Content from './Content';
import * as S from './AboutProfessional.style';
import type { ProjectPageLoader } from '@modules/project/type';

interface AboutProfessionalData {
    Professional: ProjectPageLoader['project']['Professional'];
}

interface AboutProfessionalProps {
    data: AboutProfessionalData;
}

const AboutProfessional = ({ data }: AboutProfessionalProps) => {
    const { css } = useStyles();
    const { desktop } = useAppDisplayModeContext();

    return (
        <div className={css(S.AboutProfessional)}>
            {desktop && (
                <>
                    <Heading data={data.Professional} />
                    <Content data={data.Professional} />
                </>
            )}
        </div>
    );
};

export default AboutProfessional;
